import { Box, Button, CircularProgress } from "@material-ui/core";
import Profile from "./Profile";

const TopMenu = ({
  menu,
  classes,
  parseTitle,
  loading,
  logo,
  client,
  user,
  shoppingCarts,
  statusAssociated,
}) => (
  <Box className={classes.topMenu}>
    {loading && !menu && (
      <CircularProgress
        color="secondary"
        className={classes.circularProgress}
      />
    )}
    {logo && (
      <a className={classes.logo} href="/">
        <img alt={`Logo da ${client}`} src={logo} />
      </a>
    )}
    <Box className={classes.topMenuItemsContainer}>
      {menu &&
        menu.map((item, index) => (
          <Button
            key={`menu-item-${item.title}-${index}`}
            href={item.url}
            style={item.style}
            className={classes.topMenuItem}
          >
            {parseTitle(item.title)}
          </Button>
        ))}
      <Box className={classes.authenticateContainer}>
        {user?.data ? (
          <Profile
            user={user}
            classes={classes}
            shoppingCarts={shoppingCarts ?? []}
            statusAssociated={statusAssociated}
          />
        ) : (
          <Button
            href="/login"
            variant="contained"
            className={classes.loginButton}
          >
            Login
          </Button>
        )}
      </Box>
    </Box>
  </Box>
);

export default TopMenu;
